import actionWrapper from '../../lib/actionWrapper';
import axios from '../../lib/api';
import {OrderDto} from '../type/dtos/Order';
import {PaginatedResponse} from '../../types/api';

export default {
    namespace: 'order',

    state: {
        managerOrders: null,
        orders: null,
    },

    effects: (dispatch: any) => ({
        fetchManagerOrders(query: string = '') {
            return actionWrapper(
                () => axios.get(`order/manager${query}`)
                    .then((res) => {
                        dispatch.order.fetchManagerOrders_reducer(res?.data);
                        return res;
                    }),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        fetchOrders(query: string = '') {
            return actionWrapper(
                 () => axios.get(`order${query}`)
                     .then((res) => {
                         dispatch.order.fetchOrders_reducer(res?.data);
                         return res;
                     }),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        saveOrders(data: OrderDto) {
            return actionWrapper(
                 () => axios.post('order', data),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        deleteOrder(id: number) {
            return actionWrapper(
                 () => axios.delete(`order/${id}`),
                dispatch.util.errorHandler,
                dispatch.util.sendAlert,
            );
        },
        uploadObject(data: FormData) {
            return actionWrapper(
                () => axios.post('order/upload', data),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
    }),

    reducers: {
        fetchManagerOrders_reducer(state: any, payload: PaginatedResponse<OrderDto>) {
            return {...state, managerOrders: payload};
        },
        fetchOrders_reducer(state: any, payload: PaginatedResponse<OrderDto>) {
            return {...state, orders: payload};
        },
    },
};
